import { Contact } from '@features/contacts/types/contact'

export const findContactById = (contactId: string | undefined, contacts: Contact[]): Contact | undefined => {
  return contacts.find((contact) => contact.id === contactId)
}
